<template>
	<div>
		<v-layout>
			<v-container>
				<v-flex class="main-table">
					<v-tabs fixed-tabs centered grow>

						<v-tab href="#tab-1">
							Konkursy trwające
						</v-tab>

						<v-tab href="#tab-2">
							Konkursy zakończone
						</v-tab>

						<v-tab-item value="tab-1">
							<contest-table-tab v-bind:finished="false"></contest-table-tab>
						</v-tab-item>
						<v-tab-item value="tab-2">
							<contest-table-tab v-bind:finished="true"></contest-table-tab>
						</v-tab-item>

					</v-tabs>
				</v-flex>
				<a :href="`${publicPath}eGranty - regulamin_aplikacji.pdf`" download>
					<div class="mt-3 text-lg-right regulation">
						Regulamin korzystania z aplikacji
					</div>
				</a>
				<a href="/declaration.html">
					<div class="mt-3 text-lg-right regulation">
						Deklaracja dostępności
					</div>
				</a>
				<a @click="openContactPage()" style="text-decoration: underline;">
					<div class="mt-3 text-lg-right regulation">
						Kontakt
					</div>
				</a>
			</v-container>
		</v-layout>
	</div>
</template>

<script>
import ContestTableTab from "./ContestTableTab";

export default {
	name: "ContestTable",
	components: { ContestTableTab },
	data() {
		return {
			publicPath: process.env.BASE_URL,
		};
	},
	methods: {
		openContactPage() {
			this.$router.push({name: "contact"});
		},
	}
};
</script>

<style scoped>
.theme--dark .v-tabs__div {
	font-weight: 700;
}

.theme--dark .regulation {
	color: #fff !important;

}

.theme--dark a {
	color: #fff !important;
}
</style>
